import { createContext } from 'react';

const PageWidthContext = createContext('narrow');

export { PageWidthContext as default };
//# sourceMappingURL=PageWidthContext.js.map
